export default "__VITE_ASSET__pwczIkWQ__"